"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchingTargetType = exports.ConditionSourceType = exports.ConditionType = void 0;
var ConditionType;
(function (ConditionType) {
    ConditionType["Equals"] = "Equals";
    ConditionType["NotEquals"] = "NotEquals";
    ConditionType["GreaterThan"] = "GreaterThan";
    ConditionType["GreaterThanOrEqual"] = "GreaterThanOrEqual";
    ConditionType["LessThan"] = "LessThan";
    ConditionType["LessThanOrEqual"] = "LessThanOrEqual";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
var ConditionSourceType;
(function (ConditionSourceType) {
    ConditionSourceType["Question"] = "Question";
    ConditionSourceType["Variable"] = "Variable";
})(ConditionSourceType = exports.ConditionSourceType || (exports.ConditionSourceType = {}));
var BranchingTargetType;
(function (BranchingTargetType) {
    BranchingTargetType["Page"] = "Page";
    BranchingTargetType["Override"] = "Override";
})(BranchingTargetType = exports.BranchingTargetType || (exports.BranchingTargetType = {}));
